import React from "react";
import { motion } from "framer-motion";
import { Calendar, ArrowRight, BookOpen } from "lucide-react";
import Navbar from "../../components/Navbar";

const blogs = [
  {
    title: "Understanding ISO Certifications: A Practical Guide",
    date: "Aug 15, 2025",
    category: "ISO Standards",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
    excerpt:
      "Explore how ISO certifications help organizations improve quality, compliance, and global credibility across industries."
  },
  {
    title: "HACCP & Food Safety: Why Training Matters",
    date: "Jul 28, 2025",
    category: "Food Safety",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836",
    excerpt:
      "Learn why HACCP training at different levels is critical for ensuring food safety and regulatory compliance."
  },
  {
    title: "Cyber Security & ISO 27001: What Businesses Must Know",
    date: "Jul 10, 2025",
    category: "IT Security",
    image: "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
    excerpt:
      "A strategic look at information security risks and how ISO 27001 helps organizations protect data assets."
  }
];

const Blog_Resources = () => {
  return (
    <>
    <Navbar />
    <section className="relative py-14 px-4 sm:px-6 lg:px-8 overflow-hidden">

      {/* Background Decorative Image */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1500530855697-b586d89ba3ee"
          alt="Background"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white via-white/95 to-gray-50" />
      </div>

      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mb-20"
        >
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--bg-primary)] mb-3">
            <BookOpen size={16} /> Resources & Insights
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Latest Blogs & Knowledge Hub
          </h2>
          <p className="text-gray-600 text-base md:text-lg">
            Stay informed with expert insights, industry updates, and practical guidance
            on certifications, audits, food safety, and corporate compliance.
          </p>
        </motion.div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {blogs.map((blog, index) => (
            <motion.article
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -12 }}
              className="group bg-white rounded-3xl overflow-hidden shadow-xl border border-gray-100"
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <span className="absolute top-4 left-4 text-xs font-semibold px-3 py-1 rounded-full bg-[var(--bg-primary)] text-white">
                  {blog.category}
                </span>
              </div>

              {/* Content */}
              <div className="p-7">
                <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                  <Calendar size={14} /> {blog.date}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-[var(--bg-primary)] transition-colors">
                  {blog.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-6">
                  {blog.excerpt}
                </p>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--bg-primary)] hover:gap-3 transition-all"
                >
                  Read More <ArrowRight size={16} />
                </a>
              </div>
            </motion.article>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-24 text-center"
        >
          <button className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-[var(--bg-primary)] text-white font-semibold shadow-lg hover:shadow-2xl hover:scale-105 transition-all">
            View All Blogs
          </button>
        </motion.div>

      </div>
    </section>
    </>
  );
};

export default Blog_Resources;
